module.exports = __webpack_public_path__ + "assets/img/upgrade.256afde2.png";